import { FC } from "react";

export const ComingSoon: FC = () => {
  return (
    <>
      <div className="grid h-[800px] grid-cols-[auto_minmax(0,86rem)_auto]">
        <div className="pt-[84px]">{/* empty */}</div>
        <div className="dotted-v flex flex-col items-center justify-center gap-14 px-6 pb-9 pt-[84px] lg:mx-12 lg:border-x lg:px-16">
          <h2 className="text-frecBlack bg-frecNeon font-regular px-4 text-center text-[32px] md:text-[64px]">
            Coming soon
          </h2>
        </div>
        <div className="pt-[84px]">{/* empty */}</div>
      </div>
    </>
  );
};
